import { useIsElementVisibleFromTop } from 'app/utils/hooks';
import { useRef } from 'react';

const TOP_BAR_HEIGHT = 48;
const MENU_BAR = 24;

export const useIsSticky = () => {
  const ref = useRef(null);
  const [isVisible] = useIsElementVisibleFromTop(
    ref,
    TOP_BAR_HEIGHT + MENU_BAR
  );

  return { ref, isSticky: !isVisible };
};
